import { useContext } from "react"
import ActiveFilterList from "../ActiveFilters/ActiveFilterList"
import FilterRightBar from "../FilterRightBar/FilterRightBar"
import { FilterContext } from "../FilterContext";
import QuickAccessFilters from "../QuickAccessFilters/QuickAccessFilters"
import FilterButton from "./FilterButton"

const FilterView = () => {
    const currentFilterContext = useContext(FilterContext);
    
    return (
        <>
          <div 
              className="d-flex flex-wrap"
              style={{padding: "0 10px"}}
          >   
              <FilterButton 
                onClick={currentFilterContext.toggleFilterSidebar} 
                isActive={currentFilterContext.numberOfActiveFilters > 0 ? true : false}
                isRightBarOpen={currentFilterContext.isSliderFilterOpen}
              />
              
              {/* TODO QuickAccessFilters Not Implemented <QuickAccessFilters />*/}
              {currentFilterContext.activeFilters && 
                  <ActiveFilterList filters={currentFilterContext.activeFilters}  />
              }
          </div> 
        <FilterRightBar/> 
      </>
    )
}

export default FilterView